<template>
  <section
    class="filtersSection"
  >
    <h5
      v-if="$slots.title"
      class="filtersTitle--small w-full"
    >
      <slot name="title" />
    </h5>
    <slot name="content" />
  </section>
</template>
